/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import store from '@/store';
import { USER } from '@/store/types';
import * as api from '@/api/user';
import { UserFollower } from '@/api/types/user';

export interface StoreUserFollowState {
  lists: UserFollower[];
  extra: {
    maxLimit: number;
  };
}

export default {
  namespaced: true,
  state: {
    lists: [],
    extra: {},
  },
  actions: {
    [USER.GET_FOLLOWERS]({ commit }) {
      return new Promise((resolve, reject) => {
        api.getFollowers().then((res) => {
          commit(USER.GET_FOLLOWERS, res);
          resolve();
        }).catch(reject);
      });
    },
    [USER.DEL_FOLLOWER]({ commit }, params) {
      return new Promise((resolve, reject) => {
        api.delFollowers(params.id).then(() => {
          commit(USER.DEL_FOLLOWER, params.id);
          store.dispatch(`user/other/${USER.GET_OTHER}`, { id: params.id, full: 'Y', reload: true, game: params.game });
          resolve();
        }).catch(reject);
      });
    },
    [USER.ADD_FOLLOWER](_, params) {
      return new Promise((resolve, reject) => {
        api.setFollowers(params.id).then(() => {
          store.dispatch(`user/other/${USER.GET_OTHER}`, { id: params.id, full: 'Y', reload: true, game: params.game });
          resolve();
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_FOLLOWERS](state, followers) {
      state.lists = followers.data;
      state.extra = followers.extra;
    },
    [USER.DEL_FOLLOWER](state, id) {
      state.lists.forEach((item, index) => {
        if (item.other.id === id) {
          state.lists.splice(index, 1);
        }
      });
    },
  },
};
